import React from 'react';

function AdvantagesSection() {
    const advantages = [
        {
            icon: "✅",
            title: "Гарантия до 10 лет",
            description: "Предоставляем официальную гарантию на все виды работ и материалов."
        },
        {
            icon: "👨‍👩‍👧‍👦",
            title: "Экологичность",
            description: "Используем только сертифицированные материалы, безопасные для здоровья."
        },
        {
            icon: "💰",
            title: "Доступные цены",
            description: "Предлагаем конкурентоспособные цены и гибкую систему скидок для наших клиентов."
        },
        {
            icon: "⚡",
            title: "Быстрый монтаж",
            description: "Установка натяжного потолка в комнате занимает всего 3-4 часа."
        }
    ];

    return (
        <section className="advantages-section">
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="section-title">Наши преимущества</h2>
                    <p className="section-subtitle">Что делает нас лучшими в своем деле</p>
                </div>
                <div className="row">
                    {advantages.map((advantage, index) => (
                        <div key={index} className="col-md-6 col-lg-3 animate-on-scroll">
                            <div className="advantage-item">
                                <div className="advantage-icon">{advantage.icon}</div>
                                <div className="advantage-content">
                                    <h4>{advantage.title}</h4>
                                    <p>{advantage.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default AdvantagesSection;